module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/git-1-aca9b8a7dde55c4bfaf5be97e53b349b.svg";